import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from '@mui/material';

const formatBytes = (bytes) => {
  if (!bytes || bytes <= 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB'];
  const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** exponent;

  return `${value.toFixed(exponent === 0 ? 0 : 1)} ${units[exponent]}`;
};

const AppUpdateProgressDialog = ({ status, onInstall }) => {
  const open = Boolean(status?.visible);
  const phase = status?.phase;
  const percent = typeof status?.percent === 'number' ? Math.max(0, Math.min(100, status.percent)) : null;
  const isDownloaded = phase === 'downloaded';
  const isInstalling = phase === 'installing';
  const isError = phase === 'error';
  const isChecking = phase === 'checking';
  const isPreparingDownload = phase === 'available';
  const isDownloading = phase === 'downloading';
  const showSpinner = isChecking || isInstalling || isPreparingDownload;

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
    >
      <DialogTitle sx={{ pb: 1 }}>
        {status?.title || 'Actualizando aplicacion'}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          {showSpinner ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
              <CircularProgress size={48} />
            </Box>
          ) : null}

          {isDownloading ? (
            <Box sx={{ py: 1 }}>
              <LinearProgress
                variant={percent !== null ? 'determinate' : 'indeterminate'}
                value={percent ?? 0}
                sx={{ height: 10, borderRadius: 999 }}
              />
            </Box>
          ) : null}

          <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
            {status?.message || 'Estamos preparando la actualizacion.'}
          </Typography>

          {isPreparingDownload ? (
            <Typography variant="body2" color="text.secondary">
              Cuando empiece la descarga vas a ver el porcentaje y el progreso aca.
            </Typography>
          ) : null}

          {isDownloading && percent !== null ? (
            <Typography variant="body2" color="text.secondary">
              {`${percent.toFixed(0)}% completado`}
            </Typography>
          ) : null}

          {isDownloading && status?.transferred != null && status?.total != null ? (
            <Typography variant="body2" color="text.secondary">
              {`${formatBytes(status.transferred)} de ${formatBytes(status.total)}`}
            </Typography>
          ) : null}

          {isDownloading && status?.bytesPerSecond ? (
            <Typography variant="body2" color="text.secondary">
              {`Velocidad: ${formatBytes(status.bytesPerSecond)}/s`}
            </Typography>
          ) : null}

          {isError && status?.detail ? (
            <Typography variant="body2" color="error">
              {status.detail}
            </Typography>
          ) : null}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        {isDownloaded ? (
          <Button variant="contained" onClick={onInstall}>
            Reiniciar ahora
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

export default AppUpdateProgressDialog;
